<template>
  <tr v-if="vmode === 'single'" :class="['tr-valign', {'active': active}, {'selected': selected[item.tempID]}]">

    <!-- NEW ZONE -->
    <template >
      <td v-for="(column, i) in columnSchema" :class="i === 0 ? 'sticky' : ''" :key="column.name">
        <!-- NAME -->
        <template v-if="column.name === 'Name'">
          <v-row>
            <v-icon 
            @click.stop="$emit('checkRow', item)"
            :color="selected[item.tempID] ? 'color1' : ''"> 
              {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
            </v-icon>
            <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  color="red"
                  v-on="on"
                >
                  <v-icon small>mdi-android-debug-bridge</v-icon>
                </v-btn>
              </template>
              <v-card outlined class="elevation-0">
                <v-layout class="backgroundCard pa-2 caption">
                  JSON
                </v-layout>
                <div class="c-hr"></div>
                <div class="pa-3">
                  <span class="caption">
                    {{ item }}
                    <json-viewer :item="item"></json-viewer>
                  </span>
                </div>
              </v-card>
            </v-menu>

            &nbsp;&nbsp;
            <c-input v-if="isCustomRow" :value.sync="item.json_data.name" class="crx-box-input"></c-input>
            <div v-else>
              <div>
                {{ item.definition.name }}
              </div>

              <div
              class="underline-link caption"
              @click.stop="$root.$timelineNav.open(item.archive_id)">
                RID:
                {{ item.archive_id }}
              </div>

            </div>
          </v-row>
        </template>
        <!-- Box Count -->
        <template v-if="column.name === 'Box count'">
          <c-input :value.sync="item.box_count" class="crx-box-input" :focussed.sync="boxQuantityHasFocus"></c-input>
        </template>
        <!-- Quantity per box -->
        <template v-if="column.name === 'Quantity per box'">
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue.sync="item.quantity_per_box"
          :key="'c' + (item.definition || {}).id"
          class="crx-box-input"
          ref="metricSelector"
          ></c-ms-ii>
        </template>
        <!-- Total quantity -->
        <template v-if="column.name === 'Total quantity'">
          <c-ms-ii
          v-if="isCustomRow"
          :metric_definition="item.definition" 
          :realValue.sync="item.quantity"
          :key="'c' + (item.definition || {}).id"
          :class="['text--text', 'crx-box-input borderless']"
          :focussed.sync="totalQuantityHasFocus"
          ref="metricSelector"
          ></c-ms-ii>

          <template v-else>
            <v-row class="align-center caption">
              <v-col sm="12" class="pa-0">
                <c-ms-ii
                :metric_definition="item.definition" 
                :realValue.sync="item.quantity"
                :key="'c' + (item.definition || {}).id"
                :class="[error ? 'pink--text' : 'text--text', 'crx-box-input borderless']"
                :focussed.sync="totalQuantityHasFocus"
                ref="metricSelector"
                ></c-ms-ii>
                <v-progress-linear
                class="ma-0"
                :value="percent"
                :key="item.inventory_item_id"
                :color="error ? 'pink' : 'color1'"
                background-color="backgroundCard"
                height="4"
                striped
                style="margin-bottom: 1px!important;"
                ></v-progress-linear>
              </v-col>
              <v-col sm="12" class="pa-0">
                <v-row class="align-center">
                  /&nbsp;
                  
                  <c-ms-ii
                  :metric_definition="item.definition" 
                  :realValue="totalAvailable"
                  :key="'a' + (item.definition || {}).id"
                  alwaysScale
                  labelMode
                  class="ma-2"
                  ></c-ms-ii>
                  <v-spacer></v-spacer>
                  <v-btn icon small @click="useWholeBatch">
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <v-btn icon small @click="useNoneOfBatch">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="false" class="caption grey--text align-center">
              <v-col sm="6">
                <div>
                  Reserved :
                </div>
                <c-ms-ii
                :metric_definition="item.definition" 
                :realValue="reserved"
                :key="'a' + (item.definition || {}).id"
                alwaysScale
                labelMode
                class=""
                ></c-ms-ii>
              </v-col>
              <v-col sm="6">
                <div>
                  Inventory :
                </div>
                <c-ms-ii
                :metric_definition="item.definition" 
                :realValue="totalAvailable - reserved"
                :key="'d' + (item.definition || {}).id"
                alwaysScale
                labelMode
                class="green--text"
                ></c-ms-ii>
              </v-col>
              
            </v-row>
          </template>
        </template>
        <!-- Total weight -->
        <template v-if="column.name === 'Total weight'">
          <c-ms-ii
          sid="si-mass-g"
          :realValue.sync="item.weight"
          class="crx-box-input"
          ></c-ms-ii>
        </template>
        <!-- Batch -->
        <template v-if="column.name === 'Batch'">
          <template v-if="isCustomRow">
            <c-input :value.sync="item.json_data.batch_number" class="crx-box-input"></c-input>
          </template>
          <template v-else>
            {{ item.batch_number }}
          </template>
        </template>
        <!-- BBE -->
        <template v-if="column.name === 'BBE'">
          <template v-if="isCustomRow">
            <c-date 
            class="crx-box-input"
            :date.sync="item.json_data.expiry_date">
            </c-date>
          </template>
          <template v-else>
            {{ expiryDateNormalRow }}
          </template>
        </template>
        <template v-if="column._schema">
          <!--
          <v-menu offset-x open-on-hover>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                small
                color="red"
                v-on="on"
              >
                <v-icon small>mdi-lock</v-icon>
              </v-btn>
            </template>
            <v-card outlined class="elevation-0">
              <v-layout class="backgroundCard pa-2 caption">
                SCHEMA
              </v-layout>
              <div class="c-hr"></div>
              <div class="pa-3">
                <span class="caption">
                  {{ columnSchema }}
                </span>
              </div>
            </v-card>
          </v-menu>
          -->
          <template v-if="column._schema._type === 'boolean'">
            <v-checkbox v-model="item.custom_columns[column.name]" hide-details class="ma-0"></v-checkbox>
          </template>
        </template>
      </td>
    </template>
    <!-- NEW ZONE -->

    <!--
    <td class="sticky">
      <v-row>
        <v-icon 
        @click.stop="$emit('checkRow', item)"
        :color="selected[item.tempID] ? 'color1' : ''"> 
          {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
                <json-viewer :item="item"></json-viewer>
              </span>
            </div>
          </v-card>
        </v-menu>

        &nbsp;&nbsp;
        <c-input v-if="isCustomRow" :value.sync="item.json_data.name" class="crx-box-input"></c-input>
        <div v-else>
          <div>
            {{ item.definition.name }}
          </div>

          <div
          class="underline-link caption"
          @click.stop="$root.$timelineNav.open(item.archive_id)">
            RID:
            {{ item.archive_id }}
          </div>

        </div>
      </v-row>
    </td>
    <td>
      <c-input :value.sync="item.box_count" class="crx-box-input" :focussed.sync="boxQuantityHasFocus"></c-input>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity_per_box"
      :key="'c' + (item.definition || {}).id"
      class="crx-box-input"
      ref="metricSelector"
      ></c-ms-ii>
    </td>
    <td>

      <c-ms-ii
      v-if="isCustomRow"
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :key="'c' + (item.definition || {}).id"
      :class="['text--text', 'crx-box-input borderless']"
      :focussed.sync="totalQuantityHasFocus"
      ref="metricSelector"
      ></c-ms-ii>

      <template v-else>
        <v-row class="align-center caption">
          <v-col sm="12" class="pa-0">
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue.sync="item.quantity"
            :key="'c' + (item.definition || {}).id"
            :class="[error ? 'pink--text' : 'text--text', 'crx-box-input borderless']"
            :focussed.sync="totalQuantityHasFocus"
            ref="metricSelector"
            ></c-ms-ii>
            <v-progress-linear
            class="ma-0"
            :value="percent"
            :key="item.inventory_item_id"
            :color="error ? 'pink' : 'color1'"
            background-color="backgroundCard"
            height="4"
            striped
            style="margin-bottom: 1px!important;"
            ></v-progress-linear>
          </v-col>
          <v-col sm="12" class="pa-0">
            <v-row class="align-center">
              /&nbsp;
              
              <c-ms-ii
              :metric_definition="item.definition" 
              :realValue="totalAvailable"
              :key="'a' + (item.definition || {}).id"
              alwaysScale
              labelMode
              class="ma-2"
              ></c-ms-ii>
              <v-spacer></v-spacer>
              <v-btn icon small @click="useWholeBatch">
                <v-icon small>mdi-chevron-up</v-icon>
              </v-btn>
              <v-btn icon small @click="useNoneOfBatch">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="false" class="caption grey--text align-center">
          <v-col sm="6">
            <div>
              Reserved :
            </div>
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue="reserved"
            :key="'a' + (item.definition || {}).id"
            alwaysScale
            labelMode
            class=""
            ></c-ms-ii>
          </v-col>
          <v-col sm="6">
            <div>
              Inventory :
            </div>
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue="totalAvailable - reserved"
            :key="'d' + (item.definition || {}).id"
            alwaysScale
            labelMode
            class="green--text"
            ></c-ms-ii>
          </v-col>
          
        </v-row>
      </template>
    </td>
    <td>
      <c-ms-ii
      sid="si-mass-g"
      :realValue.sync="item.weight"
      class="crx-box-input"
      ></c-ms-ii>
    </td>
    <td>
      <template v-if="isCustomRow">
        <c-input :value.sync="item.json_data.batch_number" class="crx-box-input"></c-input>
      </template>
      <template v-else>
        {{ item.batch_number }}
      </template>
    </td>
    <td>
      <template v-if="isCustomRow">
        <c-date 
        class="crx-box-input"
        :date.sync="item.json_data.expiry_date">
        </c-date>
      </template>
      <template v-else>
        {{ expiryDateNormalRow }}
      </template>
    </td>
    -->
  </tr>
  <tr v-else-if="vmode === 'group'" :class="{'selected': selected[item.tempID]}">
    <td>
      <v-row class="align-center">
        <v-icon 
        @click.stop="$emit('checkRow', item)"
        :color="selected[item.tempID] ? 'color1' : ''"> 
          {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="red"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
                <json-viewer :item="item"></json-viewer>
              </span>
            </div>
          </v-card>
        </v-menu>

        &nbsp;&nbsp;

        <div>
          <div
          class="underline-link"
          @click.stop="$root.$timelineNav.open(item.archive_id)">
            RID:
            {{ item.archive_id }}
          </div>

          <div v-if="showAllBoxesMode" class="textSecondary--text caption">
            Box {{ boxOrderIDMap[item.box] }}
          </div>
        </div>

      </v-row>

    </td>
    <td>
      <c-input :value.sync="item.box_count" class="crx-box-input" :focussed.sync="boxQuantityHasFocus"></c-input>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity_per_box"
      :key="'c' + (item.definition || {}).id"
      class="crx-box-input"
      ref="metricSelector"
      ></c-ms-ii>
    </td>
    <td>
      <template v-if="isCustomRow">
        <c-ms-ii
        :metric_definition="item.definition" 
        :realValue.sync="item.quantity"
        :key="'c' + (item.definition || {}).id"
        :class="['text--text', 'crx-box-input']"
        :focussed.sync="totalQuantityHasFocus"
        ref="metricSelector"
        ></c-ms-ii>
      </template>
      <template v-else>
        <div>
          <v-row class="align-center">
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue.sync="item.quantity"
            :key="'c' + (item.definition || {}).id"
            :class="[error ? 'pink--text' : 'text--text', 'crx-box-input']"
            ref="metricSelector"
            ></c-ms-ii>
            <v-menu offset-y open-on-hover :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  small
                  v-on="on"
                >
                  <v-icon small>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-card outlined class="pa-4 elevation-0">
                <v-row class="align-center">
                  max:&nbsp;
                  
                  <c-ms-ii
                  :metric_definition="item.definition" 
                  :realValue="totalAvailable"
                  :key="'a' + (item.definition || {}).id"
                  alwaysScale
                  labelMode
                  class="ma-2"
                  ></c-ms-ii>
                  <v-spacer></v-spacer>
                  <v-btn icon small @click="useWholeBatch">
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                  <v-btn icon small @click="useNoneOfBatch">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-card>
            </v-menu> 
          </v-row>
          <v-progress-linear
          class="ma-0 mt-1"
          :value="percent"
          :key="item.inventory_item_id"
          :color="error ? 'pink' : 'color1'"
          background-color="backgroundCard"
          height="4"
          striped
          style="margin-bottom: 1px!important;"
          ></v-progress-linear>
        </div> 

        <v-row v-if="false" class="caption grey--text align-center">
          <v-col sm="6">
            <div>
              Reserved :
            </div>
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue="reserved"
            :key="'a' + (item.definition || {}).id"
            alwaysScale
            labelMode
            class=""
            ></c-ms-ii>
          </v-col>
          <v-col sm="6">
            <div>
              Inventory :
            </div>
            <c-ms-ii
            :metric_definition="item.definition" 
            :realValue="totalAvailable - reserved"
            :key="'d' + (item.definition || {}).id"
            alwaysScale
            labelMode
            class="green--text"
            ></c-ms-ii>
          </v-col>
          
        </v-row>
      </template>
    </td>
    <td>
      <c-ms-ii
      sid="si-mass-g"
      :realValue.sync="item.weight"
      class="crx-box-input"
      ></c-ms-ii>
    </td>
    <template v-if="false">
    <td>

    </td>
    <td>

    </td>
    <td>
      <!--
      <v-row class="align-center mb-1" no-gutters>
        <v-col lg="3" sm="12">
          <div class="caption">Vat:</div>
        </v-col>
        <v-col lg="9" sm="12">
          <c-input :value.sync="item.vat" class="crx-box-input"></c-input>
        </v-col>
      </v-row>
      -->
      <c-input :value.sync="item.vat" class="crx-box-input"></c-input>
    </td>
    </template>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'
import CostPerUnit from '@/components/select/CostPerUnit'

export default {
  props: {
    item: null,
    vmode: null,
    reserved: null,
    inventoryView: null,
    mergeMap: null,
    selected: null,
    searchFilters: null,
    active: null,
    currentSelection: null,
    showAllBoxesMode: null,
    boxOrderIDMap: null,
    columnSchema: null,
  },
  components: {
    JsonViewer,
    CostPerUnit
  },
  data () {
    return {
      costPerUnit: 0,
      boxQuantityHasFocus: false,
      totalQuantityHasFocus: false
    }
  },
  computed: {
    isCustomRow () {
      if (this.item.json_data) {
        return true
      }
      return false
    },
    expiryDateNormalRow () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD.MM.YYYY')
      }
      return ''
    },
    percent () {
      return 100 - (((this.totalAvailable - this.item.quantity) / this.totalAvailable) * 100) || 0
    },
    error () {
      if (this.item.quantity > this.totalAvailable) {
        return true
      }
      return false
    },
    totalAvailable () {
      // either its in the merge map or it has inventory_id defined
      var inv_id = this.mergeMap[this.item.id] || this.item.inventory_id
      var inventory_item = this.inventoryView[this.item.inventory_item_id] || []
      var match = inventory_item.find(item => item.id === inv_id) || {}
      return match.quantity
    },
    automaticTotalQuantity () {
      // return new BigNumber(this.item.quantity_per_box).times(this.item.box_count).toNumber()
      return this.item.quantity_per_box * this.item.box_count
    },
    automaticBoxQuantity () {
      // return new BigNumber(this.item.quantity).dividedBy(this.item.quantity_per_box).toNumber()
      return this.item.quantity / this.item.quantity_per_box
    },
  },
  watch: {
    'item.quantity' (nv) {
      if (this.item.json_data) {
        // as is the case with a cusom item
        return 
      }
      this.item.weight = this.item.definition.weight * nv
    },
    automaticTotalQuantity (nv) {
      if (!this.totalQuantityHasFocus) {
        this.item.quantity = nv
      }
    },
    automaticBoxQuantity (nv) {
      if (!this.boxQuantityHasFocus) {
        this.item.box_count = nv
        if (isNaN(this.item.box_count)) {
          this.item.box_count = 0
        }
      }
    }
  },
  methods: {
    useNoneOfBatch () {
      this.item.quantity = 0
    },
    useWholeBatch () {
      this.item.quantity = this.totalAvailable
      // maybe change this
      this.item.box_count = 1
      this.item.quantity_per_box = this.totalAvailable
      // end maybe change this
      this.$nextTick(() => {
        this.$refs.metricSelector.rescale()
      })
    },
  },
  created () {
    this.item.box_count = this.automaticBoxQuantity
  }
}
</script>


<style lang="scss" scoped>
.tr-valign td {
  vertical-align: top!important;
}
</style>